import React, { forwardRef, useContext } from "react";
import PropTypes from "prop-types";

import { useUniqueId } from "../hooks/useUniqueId";
import { ThemeContext } from "../Theme";
import { FootnoteProvider } from "./FootnoteContext";
import FootnoteReference from "./FootnoteReference";
import FootnoteItem from "./FootnoteItem";
import FootnoteList from "./FootnoteList";

import styles from "./Footnote.scss";

export const Footnotes = forwardRef((props, ref) => {
  const { children, scheme, ...restProps } = props;
  const context = useContext(ThemeContext);
  let classes = scheme;
  const { id } = restProps;
  const footnotesId =
    id || `telekom-footnotes-${useUniqueId("Footnotes", props) + 1}`;

  if (!classes) {
    classes = "";
  }
  if (context) {
    classes += ` ${styles[context]}`;
  }

  return (
    <div ref={ref} className={`${styles.footnotes} ${classes}`} {...restProps}>
      <FootnoteProvider value={footnotesId}>{children}</FootnoteProvider>
    </div>
  );
});

Footnotes.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  scheme: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
};

Footnotes.defaultProps = {
  scheme: "",
};

Footnotes.Variant = {
  themeDark: "footnotes--theme_dark",
};

Footnotes.Reference = FootnoteReference;
Footnotes.List = FootnoteList;
Footnotes.Item = FootnoteItem;

Footnotes.displayName = "Footnotes";

export default Footnotes;
